import React from 'react';
import {CMSLandingHero} from '@tempo/landing';
import {Button, Box} from '@tempo/core';
import Link from 'next/link';
import {StrapiOptimizedImage} from './StrapiOptimizedImage';
import {useResolveTranslations} from '../hooks/useResolveTranslations';

type StrapiHeroBlockProps = {
	strapiBlockData: any;
	translationNamespace: string;
};

export const StrapiHeroBlock: React.FC<StrapiHeroBlockProps> = ({
	strapiBlockData,
	translationNamespace,
}) => {
	const resolve = useResolveTranslations(translationNamespace);
	const image = strapiBlockData.image?.src;
	return (
		<CMSLandingHero
			title={resolve(strapiBlockData.title).replace(/<[^>]+>/g, '')}
			description={resolve(strapiBlockData.description).replace(/<[^>]+>/g, '')}
			cta={
				<Button as={Link} href={strapiBlockData.cta?.href}>
					{resolve(strapiBlockData.cta?.label)}
				</Button>
			}
			image={
				image ? (
					<Box
						position="relative"
						w="100%"
						maxHeight={{base: '155px', md: '250px'}}
					>
						<StrapiOptimizedImage
							image={image}
							alt={resolve(strapiBlockData.image?.alt)}
							priority
							fetchPriority="high"
							loading="eager"
							sizes="(max-width: 767px) 380px, 50vw"
							style={{
								width: '100%',
								height: 'auto',
								maxHeight: '250px',
								objectFit: 'cover',
							}}
						/>
					</Box>
				) : undefined
			}
		/>
	);
};
